<template>
  <div class="wrong">
    <el-table class="question_list" :data="list" @row-click="goDetail">
      <el-table-column
        prop="parentChapterName"
        label="所属章节"
        width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-for="(item, idx) in scope.row.chapterNames" :key="idx">
            <span v-show="idx">-</span> {{ getCaption(item, 0, " ") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="question" label="题目" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="type"
        label="题型"
        :formatter="typeFormatter"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="myAnswerList"
        label="所选答案"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="answerList"
        label="正确答案"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="答题日期"
        :formatter="formatter"
        width="160"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { wrongList } from "@/api/wrongBank";
import { formatDate, checkType, getCaption } from "@/utils/index";

export default {
  data() {
    return {
      getCaption,
      list: [],
      chapters: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let classId = this.$route.query.id;
      this.$loading.show();
      wrongList({ classId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    typeFormatter(row) {
      return checkType(row.type);
    },
    goDetail(row) {
      this.$router.push({
        path: "/classCourse/wrongQuestions/detail",
        query: {
          ...this.$route.query,
          questionInfo: JSON.stringify(row),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrong {
  padding: 33px;
  background-color: rgb(255, 255, 255);
  ::v-deep .question_list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>